import React from 'react';
import { Container } from 'react-bootstrap';

import './section.scss';

export const Section = (sec) => (
    <Container fluid={true}>
        <section style={{
            textAlign: sec.textAlign || 'left'
        }}>
            <h1>
                {sec.title}
            </h1>
            <p>
                {sec.content}
            </p>
        </section>
    </Container>
)
  
  
